document.addEventListener('turbolinks:load', function() {
  I18n.defaultLocale = "en";
  I18n.locale = $('meta[name=locale]')[0].content;
})
